import React from 'react';
import { UserCog } from 'lucide-react';
import { useApplicationReview } from '../../../contexts/ApplicationReviewContext';
import { reviewRoles, roleDuties } from '../../../data/applicationReview';
import type { ReviewRole } from '../../../types/review';
export function RoleSwitcher() {
  const {
    role,
    setRole,
    user
  } = useApplicationReview();
  return <div className="flex items-center gap-2.5 rounded-lg border border-navy-200 bg-navy-50 px-3 py-1.5" data-id="element-559" data-mp="3js8dhkaba8lt">
      <UserCog className="h-4 w-4 shrink-0 text-navy-700" data-id="element-560" data-mp="1i6frdwegqlw" />
      <div className="leading-tight" data-id="element-561" data-mp="3tjcoya0s3bbw">
        <label htmlFor="review-role" className="block text-[10px] font-semibold text-navy-600" data-id="element-562" data-mp="3tmgxtkp6uv8w">বর্তমান ভূমিকা (প্রোটোটাইপ)</label>
        <select id="review-role" value={role} onChange={e => setRole(e.target.value as ReviewRole)} className="-ml-0.5 bg-transparent text-[13px] font-semibold text-navy-900 outline-none" data-id="element-563" data-mp="6ewqrmtckw0g">
          {reviewRoles.map(r => <option key={r.role} value={r.role} data-id="element-564" data-mp="2894j8c9ml4u5">{r.role}</option>)}
        </select>
        <p className="text-[10.5px] text-slate-500" title={roleDuties[role]} data-id="element-565" data-mp="zz2f95hu0afl">{user.user}</p>
      </div>
    </div>;
}